import React from 'react';
import {ButtonBase} from '@material-ui/core';
import QCTooltip from '@pluto/qc-tooltip';
import {
    CreateAdBreakIcon,
    CreateNoteIcon,
    CreateMarkupIcon,
    GoToPrevious,
    GoToNext,
} from '../../icons';

import './MarkerControls.scss';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

interface MarkerControlsProps {
    onCreateQCNote: () => void;
    onCreateAdBreak: () => void;
    onCreateMarkup: () => void;
    onNextMarker: () => void;
    onPreviousMarker: () => void;
    onGetSnapshot: () => void;
    jobDeliveryDate: string;
}

export default function MarkerControls(props: MarkerControlsProps) {
    const {
        onCreateQCNote,
        onCreateAdBreak,
        onCreateMarkup,
        onNextMarker,
        onPreviousMarker,
        onGetSnapshot,
        jobDeliveryDate,
    } = props;

    return (
        <div className="flex-container center-container">
            <QCTooltip title="Add Note (C)" arrow>
                <span>
                    <ButtonBase
                        onClick={onCreateQCNote}
                        aria-label="Add Note"
                        aria-keyshortcuts="C"
                        disabled={Boolean(jobDeliveryDate)}
                    >
                        <CreateNoteIcon />
                    </ButtonBase>
                </span>
            </QCTooltip>
            <QCTooltip title="Add Breakpoint (V)" arrow>
                <span>
                    <ButtonBase
                        onClick={onCreateAdBreak}
                        aria-label="Add Breakpoint"
                        aria-keyshortcuts="V"
                        disabled={Boolean(jobDeliveryDate)}
                    >
                        <CreateAdBreakIcon />
                    </ButtonBase>
                </span>
            </QCTooltip>
            <QCTooltip title="Add Markup (B)" arrow>
                <span>
                    <ButtonBase
                        onClick={onCreateMarkup}
                        aria-label="Add Markup"
                        aria-keyshortcuts="B"
                        disabled={Boolean(jobDeliveryDate)}
                    >
                        <CreateMarkupIcon />
                    </ButtonBase>
                </span>
            </QCTooltip>
            <div className="flex-container snapshot">
                <ButtonBase onClick={onGetSnapshot}>
                    <PhotoCameraIcon/>
                </ButtonBase>
            </div>
            <QCTooltip title="Go to Previous Marker (Ctrl + Shift + C)" arrow>
                <ButtonBase
                    onClick={onPreviousMarker}
                    aria-label="Go to Previous Marker"
                    aria-keyshortcuts="Ctrl+Shift+C"
                >
                    <GoToPrevious />
                </ButtonBase>
            </QCTooltip>
            <QCTooltip title="Go to Next Marker (Shift + C)" arrow>
                <ButtonBase
                    onClick={onNextMarker}
                    aria-label="Go to Next Marker"
                    aria-keyshortcuts="(Shift + C)"
                >
                    <GoToNext />
                </ButtonBase>
            </QCTooltip>
        </div>
    );
}
